import { LazyWebpImage, WebpImage } from 'components/Shared/SharedComponents';
import { ViewerDevice } from 'constants/enums';

export const getImageBasedDevice = (
  viewerDevice?: ViewerDevice,
) => ((viewerDevice === ViewerDevice.MOBILE)
  ? LazyWebpImage
  : WebpImage);
